import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const stepsWrapper = document.querySelector('.section-steps');

if (stepsWrapper) {
  const steps = stepsWrapper.querySelectorAll('.item-step');
  const blockSteps = stepsWrapper.querySelector('.block-steps');
  const width = window.innerWidth;

  ScrollTrigger.create({
    trigger: width > 992 ? stepsWrapper : blockSteps,
    start: 'center-=50px center',
    end: '+=1000',
    pin: '.main',
    scrub: 0.1,
    onUpdate: (self) => {
      const totalProgress = self.progress;
      const sectionCount = steps.length;

      steps.forEach((el, i) => {
        const start = i / sectionCount;
        const end = (i + 1) / sectionCount;

        let localProgress = (totalProgress - start) / (end - start);
        localProgress = Math.max(0, Math.min(1, localProgress));

        const percent = Math.round(localProgress * 100);
        el.style.setProperty('--progress', percent);

        if (localProgress > 0) {
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
        }
      });
    }
  });
}

